import StatBase from "./StatBase";
import { StatProvider } from "src/context/StatContext";
import { useEffect } from "react";
import AuthAccess from "src/data/auth/authAccess/AuthAccess";
import LazyLoader from "src/components/layout/Progress/LazyLoader";
import { scroll6IfTop } from "src/components/js/statics1";

export default function StatCore() {
  useEffect(() => {
    document.title = "Raport";
    localStorage.setItem("lastKnownUrl", window.location.pathname);
    scroll6IfTop();
  }, []);

  return (
    <AuthAccess page="raport" showError>
      <StatProvider>
        <LazyLoader>
          <StatBase />
        </LazyLoader>
      </StatProvider>
    </AuthAccess>
  );
}
